// @type
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import Text from './shared/Typography';
import Card from './shared/Card';
import ObservationChart from './observation-chart';
import DictionaryFloater from './shared/DictionaryFloater';
import SafeHTML from './shared/SafeHTML';

import type { ObservationType } from './../types/observation';

type Props = {
  obs: ObservationType,
  id: number
} & WithTranslation

type State = {
  hasDefinition: Boolean
}

class RecordObservationCard extends React.Component<Props, State> {
  state: State = {
    hasDefinition: false
  }

  props: Props;

  componentWillMount() {
    let foundDefinition = false;
    let definition = '';
    let formalName = '';
    const { t } = this.props;
    const dictionary = t('definitions:all', { returnObjects: true });
    const name = this.props.obs && this.props.obs.name;
    const word = name && name.text.toLowerCase();
    // Stage One: Only search through the first entry for the "primary" definitions
    dictionary.forEach((definedTerm) => {
      if (definedTerm.primary_term.toLowerCase() === word) {
        formalName = definedTerm.primary_term;
        foundDefinition = true;
        definition = definedTerm.definition;
      }
    });
    // Stage Two, only occur if first stage failed, searches all alternative terms
    if (!foundDefinition) {
      dictionary.forEach((definedTerm) => {
        definedTerm.alt_terms.forEach((term) => {
          if (term.toLowerCase() === word) {
            formalName = definedTerm.primary_term;
            foundDefinition = true;
            definition = definedTerm.definition;
          }
        });
      });
    }

    this.setState({
      hasDefinition: foundDefinition,
      definition: definition,
      formalName: formalName
    });
  }

  render() {
    const { obs, t } = this.props;
    const { name, referenceRange, unit, result, id, comment, interpretation } = obs;
    const commentIsJunk = comment === '<p><br /></p>'
      || comment === '<p><span></span></p>'
      || comment === '<p></p>'
      || comment === '<div><p></p></div>'
      || comment === '<div><p><br /></p></div>';

    const flag = interpretation && interpretation.text;
    const isResultNaN = isNaN(parseFloat(result));

    return (
      <Card
        noShadow
        noPadding
        className='record-observation__card'
        key={obs && obs.id}
      >
        {/* result */}
        {obs &&
          <div className='record-observation__card__sub-container-1'>
            {this.state.hasDefinition ? (
              <DictionaryFloater
                header={t('observationCard:what_does_this_mean')}
                title={this.state.formalName}
                text={this.state.definition}
                footer={t('observationCard:adapted_from_lexicomp')}
                id={this.props.id}
              >
                <Text chartTitle className='record-observation__dictionary-term'>
                  {name.text}
                </Text>
              </DictionaryFloater>
            ) : <Text chartTitle>{name.text}</Text>
            }
            <div className='record-observation__result__container'>
              {flag && (
                <Text
                  tag
                  align='left'
                  className={flag.toLowerCase() !== 'normal' ?
                    'record-observation__flag--high'
                    : 'record-observation__flag'}
                >
                  {flag}
                </Text>)}

              {result.toLowerCase() === 'positive' || result.toLowerCase() === 'negative' ? (
                <Text
                  span
                  className={
                    result.toLowerCase() === 'positive' ?
                    'record-observation__result is-positive'
                    : 'record-observation__result is-negative'}
                >
                  {result}
                </Text>)
                : (
                  <Text
                    span
                    className={flag && flag.toLowerCase() !== 'normal' ?
                      'record-observation__result--high'
                      : 'record-observation__result'}
                  >
                    {result} {unit && unit.text}
                  </Text>
                )
              }
            </div>
          </div>
        }
        {/* range -- graph will not render without range */}
        {referenceRange && !isResultNaN &&
          <div className={`record-observation__card__sub-container-2 ${!comment && 'rounded-bottom-corners'}`}>
            {referenceRange.map((range) => (
              <ObservationChart
                result={result}
                low={parseFloat(range.low)}
                high={parseFloat(range.high)}
                key={id}
              />
            ))}
          </div>}

        {comment && !commentIsJunk &&
          <div className='record-observation__card__notes record-detail__generated-rx-notes'>
            <SafeHTML text={comment} />
          </div>}
      </Card>
    );
  }
}

export default withTranslation(['observationCard', 'definitions'])(RecordObservationCard);



// WEBPACK FOOTER //
// ./src/components/observation-card.js